var module = angular.module('octopusApp.tenants');

module.directive('tenantsProjectSelector', function () {
    return {
        restrict: 'E',
        replace: true,
        transclude: false,
        scope: {
            tenant: '='
        },
        templateUrl: 'areas/tenants/views/tenants-project-selector.html',
        controllerAs: 'vm',
        bindToController: true,
        link: function ($scope) {

        },
        controller: function ($q, $uibModal, busy, unsavedChanges, octopusPermissionSet, octopusRepository) {
            var vm = this;
            vm.isLoading = busy.create();
            vm.editProjectEnvironmentMapping = editProjectEnvironmentMapping;
            vm.addProjectEnvironmentMapping = addProjectEnvironmentMapping;
            vm.removeProjectEnvironmentMapping = removeProjectEnvironmentMapping;
            vm.environmentsById = {};
            vm.projectsById = {};

            function init() {

                vm.isLoading.promise(permissionCheck()
                    .then(function (isAuthorized) {
                        if (!isAuthorized) {
                            return;
                        }

                        buildProjectEnvironmentMap();
                    }));
            }


            function loadEnvironments() {
                var environmentIds = _.unique(_.flatten(_.values(vm.tenant.ProjectEnvironments)));
                if (_.any(environmentIds, function (envId) { return !vm.environmentsById[envId]; })) {
                    return octopusRepository.Environments.all({ids: environmentIds}).then(function (environments) {
                        vm.environmentsById = _.object(_.pluck(environments, "Id"), environments);
                    });
                }
                return $q.resolve();
            }

            function loadProjects() {
                var projectIds = Object.keys(vm.tenant.ProjectEnvironments);
                if (_.any(projectIds, function (pid) { return !vm.projectsById[pid]; })) {
                    return octopusRepository.Projects.all({ids: projectIds}).then(function (projects) {
                        vm.projectsById = _.object(_.pluck(projects, "Id"), projects);
                    });
                }
                return $q.resolve();
            }

            function permissionCheck() {
                return octopusPermissionSet.isAuthorized({
                    permission: 'ProjectView',
                    projectId: '*'
                }).then(function (isAuthorized) {
                    if (!isAuthorized) {
                        return false;
                    }
                    return octopusPermissionSet.isAuthorized({permission: 'EnvironmentView', environmentId: '*'});
                });
            }

            function buildProjectEnvironmentMap() {
                vm.isLoading.promise($q.all([loadProjects(), loadEnvironments()]).then(function () {
                    if (vm.tenant && vm.projectsById && vm.environmentsById) {
                        vm.projectEnvironmentMap = _.chain(vm.tenant.ProjectEnvironments).map(function (environmentIds, projectId) {
                            return {
                                project: vm.projectsById[projectId],
                                environments: _.chain(environmentIds).map(function (id) {
                                    return vm.environmentsById[id];
                                }).filter(function (environment) {
                                    return !!environment;
                                }).sortBy(function (environment) {
                                    return environment.SortOrder;
                                }).value()
                            };
                        }).filter(function (x) {
                            return !!x.project;
                        }).sortBy(function (x) {
                            return x.project.Name;
                        }).value();
                    }
                }));
            }

            function editProjectEnvironmentMapping(projectId) {
                var mapping = _.find(vm.projectEnvironmentMap, function (map) {
                    return map.project.Id === projectId;
                });
                $uibModal.open({
                    backdrop: true,
                    keyboard: true,
                    templateUrl: 'areas/tenants/views/tenant_edit_project_dialog.html',
                    controller: 'TenantEditProjectDialogController',
                    resolve: {
                        project: function () {
                            return mapping.project;
                        },
                        environments: function () {
                            return mapping.environments;
                        }
                    }
                }).result.then(function (result) {
                    if (result) {
                        var unavailableEnvironments = vm.tenant.ProjectEnvironments[projectId].filter(function(envId) {
                            return !_.any(mapping.environments, function(e) { return e.Id === envId; });
                        });
                        vm.tenant.ProjectEnvironments[projectId] = unavailableEnvironments.concat(result.environmentIds);
                        buildProjectEnvironmentMap();
                        unsavedChanges.unsaved();
                    }
                });
            }

            function addProjectEnvironmentMapping() {
                var existingProjects = _.pluck(vm.projectEnvironmentMap, 'project');

                $uibModal.open({
                    backdrop: true,
                    keyboard: true,
                    templateUrl: 'areas/tenants/views/tenant_add_project_dialog.html',
                    controller: 'TenantAddProjectDialogController',
                    resolve: {
                        existingProjects: function () {
                            return existingProjects;
                        }
                    }
                }).result.then(function (result) {
                    if (result) {
                        if (_.contains(vm.tenant.ProjectIds, result.ProjectId)) {
                            return;
                        }
                        unsavedChanges.unsaved();
                        vm.tenant.ProjectEnvironments[result.ProjectId] = result.Environments;
                        buildProjectEnvironmentMap();
                    }
                });
            }

            function removeProjectEnvironmentMapping(projectId) {
                delete vm.tenant.ProjectEnvironments[projectId];
                buildProjectEnvironmentMap();
                unsavedChanges.unsaved();
            }

            init();
        }
    };
});


//////////////////
// WEBPACK FOOTER
// ./app/areas/tenants/directives/tenants-project-selector.js
// module id = 635
// module chunks = 1